import React from 'react'

import { getEnterpriseAIContent } from '../../constants/enterpriseAIContent'

const EnterpriseAIMetrics = ({ lang }) => {
  const { metrics } = getEnterpriseAIContent(lang)

  return (
    <section className="enterprise-ai-metrics" aria-labelledby="enterprise-ai-metrics-heading">
      <div className="content container">
        <h2 id="enterprise-ai-metrics-heading" className="enterprise-ai-metrics__heading">
          {metrics.headingLines.map(line => (
            <span key={line} className="enterprise-ai-metrics__heading-line">
              {line}
            </span>
          ))}
        </h2>
        <div className="enterprise-ai-metrics__grid">
          {metrics.items.map(item => (
            <article key={item.value} className="enterprise-ai-metrics__card">
              <p className="enterprise-ai-metrics__value">{item.value}</p>
              <p className="enterprise-ai-metrics__label">{item.label}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}

export default EnterpriseAIMetrics
